"use strict";
var Observable_1 = require('../../Observable');
var bindNodeCallback_1 = require('../../observable/bindNodeCallback');
Observable_1.Observable.bindNodeCallback = bindNodeCallback_1.bindNodeCallback;
//# sourceMappingURL=bindNodeCallback.js.map


/*****************
 ** WEBPACK FOOTER
 ** F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/~/rxjs/add/observable/bindNodeCallback.js
 ** module id = 64
 ** module chunks = 2
 **/